module.exports = __webpack_public_path__ + "static/img/bottbg.7897b5ae.png";